import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getWorkspaceProfile } from "@/api/resources/workspaceProfiles/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("workspace-profile");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};

export const workspaceProfilesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "workspaceProfiles"],
  byId: (workspace_id?: string) => [...workspaceProfilesQueryKeys.all(), "byId", workspace_id],
};

export const workspaceProfilesQueries = {
  byId: (workspace_id?: string) =>
    queryOptions({
      queryKey: [...workspaceProfilesQueryKeys.byId(workspace_id)],
      queryFn: workspace_id ? () => getWorkspaceProfile({ match: { workspace_id } }) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
